/* FleetPro RETAIL — interactive localStorage wishlist.
   Hearts (.fp-wish) toggle items; the wishlist page renders cards with
   Add to cart, sort, totals, add-all, clear-all and toasts. Device-local, no app. */
(function () {
  if (window.__fpWishlistInit) return;
  window.__fpWishlistInit = true;

  var KEY = 'fp_wishlist_v1';
  var SORTKEY = 'fp_wishlist_sort';
  var toastTimer = null;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} sync(list); }
  function getSort() { try { return localStorage.getItem(SORTKEY) || 'added'; } catch (e) { return 'added'; } }
  function setSort(v) { try { localStorage.setItem(SORTKEY, v); } catch (e) {} }
  function inList(list, id) { return list.some(function (x) { return String(x.id) === String(id); }); }
  function truthy(v) { return v === true || v === 'true' || v === '1' || v === 1; }
  function croot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function attrs(p) {
    return ' data-id="' + esc(p.id) + '" data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) +
      '" data-url="' + esc(p.url) + '" data-image="' + esc(p.image) + '" data-price="' + esc(p.price) +
      '" data-compare="' + esc(p.compare) + '" data-vendor="' + esc(p.vendor) + '" data-variant="' + esc(p.variant) +
      '" data-available="' + esc(p.available) + '" data-single="' + esc(p.single) +
      '" data-price-cents="' + esc(p.priceCents) + '" data-compare-cents="' + esc(p.compareCents) + '"';
  }

  function sync(list) {
    list = list || read();
    document.querySelectorAll('[data-fp-wish-count]').forEach(function (el) {
      el.textContent = list.length; el.hidden = list.length === 0;
    });
    document.querySelectorAll('.fp-wish').forEach(function (b) {
      var on = inList(list, b.getAttribute('data-id'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('title', on ? 'In wishlist' : 'Add to wishlist');
    });
  }

  function toggle(btn) {
    var list = read();
    var id = btn.getAttribute('data-id');
    if (inList(list, id)) {
      list = list.filter(function (x) { return String(x.id) !== String(id); });
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-handle'),
        title: btn.getAttribute('data-title'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price'),
        compare: btn.getAttribute('data-compare'),
        url: btn.getAttribute('data-url'),
        vendor: btn.getAttribute('data-vendor'),
        variant: btn.getAttribute('data-variant'),
        available: btn.getAttribute('data-available'),
        single: btn.getAttribute('data-single'),
        priceCents: parseInt(btn.getAttribute('data-price-cents') || '0', 10),
        compareCents: parseInt(btn.getAttribute('data-compare-cents') || '0', 10),
        addedAt: Date.now()
      });
    }
    store(list);
    renderPage();
  }

  function sortList(list) {
    var s = getSort();
    var a = list.slice();
    if (s === 'price-asc') a.sort(function (x, y) { return (x.priceCents || 0) - (y.priceCents || 0); });
    else if (s === 'price-desc') a.sort(function (x, y) { return (y.priceCents || 0) - (x.priceCents || 0); });
    else if (s === 'title') a.sort(function (x, y) { return String(x.title).localeCompare(String(y.title)); });
    else a.sort(function (x, y) { return (y.addedAt || 0) - (x.addedAt || 0); });
    return a;
  }

  var heartSvg = '<svg class="fp-wish__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.49 4.04 3 5.5l7 7Z"/></svg>';
  var cartSvg = '<svg class="fpc__ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>';
  var checkSvg = '<svg class="fpc__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function card(p) {
    var avail = truthy(p.available);
    var cc = p.compareCents || 0, pc = p.priceCents || 0;
    var sale = '';
    if (cc > pc && cc > 0) sale = '<span class="fpc__sale">Save ' + Math.round((cc - pc) / cc * 100) + '%</span>';
    var media = '<div class="fpc__media">' +
      '<button type="button" class="fp-wish is-on" aria-label="Remove from wishlist" aria-pressed="true"' + attrs(p) + '>' + heartSvg + '</button>' +
      (avail ? '<span class="fpc__stk">In stock</span>' : '<span class="fpc__stk fpc__stk--out">Out of stock</span>') +
      sale +
      (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' :
        '<svg class="fpc__ph" viewBox="0 0 24 24" fill="none" stroke="#C2CAD4" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.2"/></svg>') +
      '</div>';
    var cta;
    if (avail && truthy(p.single) && p.variant) {
      cta = '<button type="button" class="fpc__btn" data-fp-add data-variant="' + esc(p.variant) + '">' + cartSvg + 'Add to cart</button>';
    } else if (avail) {
      cta = '<a class="fpc__btn" href="' + esc(p.url) + '">' + cartSvg + 'Choose options</a>';
    } else {
      cta = '<button type="button" class="fpc__btn fpc__btn--out" disabled>Out of stock</button>';
    }
    var body = '<div class="fpc__in">' +
      (p.vendor ? '<span class="fpc__br">' + esc(p.vendor) + '</span>' : '') +
      '<a class="fpc__nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="fpc__pr"><b>' + esc(p.price) + '</b>' + (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') + '</div>' +
      cta + '</div>';
    return '<div class="fpc" data-wish-card="' + esc(p.id) + '">' + media + body + '</div>';
  }

  function renderPage() {
    var root = document.querySelector('[data-fp-wishlist-root]');
    if (!root) { sync(); return; }
    var list = read();
    var bar = document.querySelector('[data-fp-wish-bar]');
    var empty = document.querySelector('[data-fp-wishlist-empty]');
    var totalEl = document.querySelector('[data-fp-wish-total]');
    var sumEl = document.querySelector('[data-fp-wish-sum]');

    if (totalEl) totalEl.textContent = list.length;
    if (sumEl) sumEl.textContent = money(list.reduce(function (s, p) { return s + (p.priceCents || 0); }, 0));

    if (!list.length) {
      root.innerHTML = '';
      if (bar) bar.hidden = true;
      if (empty) empty.hidden = false;
      sync(list);
      return;
    }
    if (bar) bar.hidden = false;
    if (empty) empty.hidden = true;
    root.innerHTML = sortList(list).map(card).join('');
    sync(list);
  }

  function toast(msg, ok) {
    var el = document.querySelector('[data-fp-toast]');
    if (!el) return;
    el.innerHTML = (ok ? checkSvg : '') + '<span>' + esc(msg) + '</span>';
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, 220);
    }, 1900);
  }

  function refreshCart() {
    fetch(croot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-fp-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
      })['catch'](function () {});
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.disabled = true;
    fetch(croot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      toast('Added to cart', true);
      refreshCart();
      if (btn) {
        var html = btn.innerHTML;
        btn.classList.add('is-added');
        btn.innerHTML = checkSvg + 'Added';
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = html; }, 1500);
      }
    })['catch'](function () {
      toast('Could not add — open product');
      if (btn) btn.disabled = false;
    });
  }

  function addAll() {
    var items = read().filter(function (p) { return truthy(p.available) && truthy(p.single) && p.variant; })
      .map(function (p) { return { id: p.variant, quantity: 1 }; });
    if (!items.length) { toast('No in-stock items to add'); return; }
    fetch(croot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      toast(items.length + (items.length === 1 ? ' item added' : ' items added'), true);
      refreshCart();
    })['catch'](function () { toast('Could not add items'); });
  }

  function clearAll() {
    if (!read().length) return;
    if (!window.confirm('Remove all items from your wishlist?')) return;
    store([]);
    renderPage();
    toast('Wishlist cleared');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var add = t.closest('[data-fp-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-variant'), add); return; }
    if (t.closest('[data-fp-wish-addall]')) { e.preventDefault(); addAll(); return; }
    if (t.closest('[data-fp-wish-clear]')) { e.preventDefault(); clearAll(); return; }

    var heart = t.closest('.fp-wish');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      var cardEl = heart.closest('[data-wish-card]');
      if (cardEl) {
        cardEl.classList.add('is-removing');
        setTimeout(function () { toggle(heart); }, 190);
      } else {
        toggle(heart);
      }
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-fp-wish-sort]') : null;
    if (!sel) return;
    setSort(sel.value);
    renderPage();
  });

  var syncTimer = null;
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { sync(); }, 120); }

  function boot() {
    var sel = document.querySelector('[data-fp-wish-sort]');
    if (sel) sel.value = getSort();
    sync();
    renderPage();

    // Re-sync heart states when product grids are swapped by AJAX (Globo filters / pagination / infinite scroll).
    // Reacts only to inserted ELEMENT nodes that contain a heart - ignores our own textContent writes, so no loop.
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var an = muts[i].addedNodes;
          for (var j = 0; j < an.length; j++) {
            var n = an[j];
            if (n.nodeType === 1 && ((n.matches && n.matches('.fp-wish, product-card, .card-product')) || (n.querySelector && n.querySelector('.fp-wish')))) {
              scheduleSync();
              return;
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    window.addEventListener('pageshow', function () { sync(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
